import { Route } from "react-router-dom";
import AppSections from "../utils/AppSections";
import ProtectedRoute from "./ProtectedRoute";
import Pilots from "../ui/pilots/Pilots";
import PilotsList from "../ui/pilots/PilotsList";
import PilotAddEdit from "../ui/pilots/PilotAddEdit";
import PilotDetails from "../ui/pilots/PilotDetails";

const PilotsRoutes = (
  <Route
    path={AppSections.PILOTS}
    element={
      <ProtectedRoute>
        <Pilots />
      </ProtectedRoute>
    }
  >
    <Route path="/pilots/" element={<PilotsList />} />
    <Route path="create" element={<PilotAddEdit />} />
    <Route path=":id/view" element={<PilotDetails />} />
    <Route path=":id/edit" element={<PilotAddEdit />} />
  </Route>
);

export default PilotsRoutes;
